import React, { useState } from 'react'
import { useQuery } from '@apollo/react-hooks'
import dayjs from 'dayjs'
import { Button } from 'konsys-ui'
import { Modal } from 'antd'
import Axios from 'axios'
import fileDownload from 'js-file-download'
import { formatDateRange } from '../../utils/util-services'
import { TRUCK_USED_LOG } from '../../constants/graphql/query'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const ModalImage = ({ image }) => {
  const [modal, setModal] = useState(false)
  return (
    <>
      <div className="w-14 h-14 bg-gray-200 rounded flex items-center justify-center group cursor-pointer" onClick={() => setModal(true)}>
        <img
          src={image.url}
          alt="Truck Condition"
          className="w-full h-full object-cover rounded"
        />
      </div>
      <Modal
        title="รูปภาพ"
        visible={modal}
        onCancel={() => setModal(false)}
        width={1080}
        footer={null}
      >
        <img src={image.url} alt="Truck Condition" className=" object-cover rounded mx-auto" />
      </Modal>
    </>
  )
}


// VehicleConditionImages component
const VehicleConditionImages = ({ images }) => (
  <div className="flex space-x-1 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
    {images.map(image => (
      <div key={image.id} className="flex-shrink-0">
        <ModalImage image={image} />
      </div>
    ))}
  </div>
)

// HistoryRow component
const HistoryRow = ({ item }) => (
  <div className="grid grid-cols-24 gap-4 px-4 py-4 border-b border-gray-200 bg-white my-2 rounded-sm">
    <p className="text-black text-base col-span-3">{formatDateRange(item.startDate, item.endDate)}</p>
    <div className="text-black text-base col-span-5">
      {
        item.startDate && item.endDate
        ? dayjs(item.endDate).diff(dayjs(item.startDate), 'day') + 1
        : '-'
      } วัน
    </div>
    <div className="text-black text-base col-span-3">{item.truck.plateNumber}</div>
    <div className="text-black text-base col-span-3">{item.trailer.trailerPlate}</div>
    <div className="text-black text-base border-r border-gray-200 col-span-3">{item.driver.fullname}</div>
    <div className="flex items-center space-x-2 col-span-7">
      <VehicleConditionImages images={item.files} />
    </div>
  </div>
)

const TruckHistoryPage = ({ props }) => {
  const [isLoading, setIsLoading] = useState(false)
  // In real usage, replace with GraphQL queries
  const { data, loading, error } = useQuery(TRUCK_USED_LOG, { variables: { truckId: parseInt(props.match.params.id, 10) } })
  const historyData = data?.TruckUsedLogs?.truckUsedLogs || []

  const download = () => {
    setIsLoading(true)
    Axios({
      method: 'GET',
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
      url: `${getURL().FILE_SERVER}/download/excel/truck/shippingorders/${props.match.params.id}`,
    }).then((resp) => {
      fileDownload(resp.data, 'รายงานข้อมูลการใช้งานรถบรรทุก.xlsx')
      setIsLoading(false)
    })
  }
  if (loading) {
    return (
      <div className="flex justify-center items-center h-48 text-base text-gray-600 font-inter">
        กำลังโหลด...
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-48 text-base text-red-500 font-inter">
        เกิดข้อผิดพลาด: {error?.message || 'ไม่สามารถโหลดข้อมูลได้'}
      </div>
    )
  }

  // In real usage, get registration from truckData
  const truckRegistration = historyData[0]?.truck?.plateNumber || ''

  // In real usage, process historyData from API

  return (
    <div className="flex flex-col font-inter min-h-screen">
      {/* Header Section */}
      <div className="mb-4 flex justify-between items-center">
        <p className="text-2xl font-semibold text-primary font-inter">
          ประวัติการใช้งาน หัวลาก ทะเบียน {truckRegistration}
        </p>
        <Button loading={isLoading} icon="fas fa-download" text="ดาวน์โหลดรายงานข้อมูลการใช้งานรถบรรทุก" type="primary" onClick={() => {
          download()
        }} />
      </div>

      {/* History List */}
      <div className="pb-10">
        {/* Header Row */}
        <div className="grid grid-cols-24 gap-4 px-4 py-3 font-bold text-gray-700">
          <div className="text-lg text-gray-500 font-semibold col-span-3">วันที่เริ่ม และ สิ้นสุด</div>
          <div className="text-lg text-gray-500 font-semibold col-span-5">รวมระยะเวลาการใช้งาน</div>
          <div className="text-lg text-gray-500 font-semibold col-span-3">ทะเบียนหัว</div>
          <div className="text-lg text-gray-500 font-semibold col-span-3">ทะเบียนหาง</div>
          <div className="text-lg text-gray-500 font-semibold col-span-3">คนขับ</div>
          <div className="col-span-7 text-lg text-gray-500 font-semibold">สภาพรถ</div>
        </div>
        {historyData.map(item => (
          <HistoryRow key={item.id} item={item} />
        ))}
      </div>
    </div>
  )
}

export default TruckHistoryPage
